import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $vid: this.el._$('.inline-video__video'),
      $preview: this.el._$('.inline-video__preview'),
      $img: this.el._$('.inline-video__preview img'),
      $playButton: this.el._$('.inline-video__play')
    };

    this.service = this.el.dataset.videoService;
    this.id = this.el.dataset.videoId;

    if (!this.dom.$playButton) {
      this.el._on('reset', this.reset.bind(this));
      this.playVideo();
    }
  }

  addListeners() {
    if (this.dom.$playButton) {
      this.dom.$playButton._on('click', this.playVideo.bind(this));
    } else {
      this.el._on('click', this.clicked.bind(this));
    }
  }

  clicked() {
    console.log('clicked');
  }

  buildSrc() {
    if (this.service === 'vimeo') {

      const privateArray = this.id?.split('/');

      if (privateArray.length > 1) {
        return `https://player.vimeo.com/video/${privateArray[0]}?h=${privateArray[1]}`;
      }

      return `https://player.vimeo.com/video/${this.id}`;
    }

    return `https://players.brightcove.net/${
      window?.ue?.brightcoveAccountId
    }/default_default/index.html?videoId=${this.id}&${
      this.dom.$playButton ? '&' : ''
    }playsinline=true`;
  }

  createIframe() {
    const $iframe = document.createElement('iframe');
    $iframe.classList.add('inline-video__video');
    $iframe.src = this.buildSrc();
    $iframe.setAttribute('aria-label', this.el.dataset.ariaLabel);
    $iframe.setAttribute('frameborder', '0');
    $iframe.setAttribute('allow', 'fullscreen');
    return $iframe;
  }

  playVideo() {
    this.dom.$iframe = this.createIframe();
    this.el.prepend(this.dom.$iframe);
    this.dom.$preview?.remove?.();

    const event = new CustomEvent('videoinitiated');
    this.el.dispatchEvent(event);
  }

  reset() {
    this.dom.$iframe?.remove?.();
    const event = new CustomEvent('resetcomplete');
    this.el.dispatchEvent(event);

    if (this.dom.$playButton) {
      this.dom.$playButton.setAttribute('tabindex', -1);
    } else {
      this.playVideo();
    }
  }
}

export default Module;
